import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f133d1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidGeneral" }
const _hoisted_2 = { class: "FTLBidGeneral__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Основная информация", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Авто", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = {
  key: 0,
  class: "fas fa-check text-green-500"
}
const _hoisted_10 = {
  key: 1,
  class: "fas fa-times text-red-500"
}
const _hoisted_11 = { class: "block__field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Клиент", -1))
const _hoisted_13 = { class: "field__value" }
const _hoisted_14 = { class: "block__field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Создатель", -1))
const _hoisted_16 = { class: "field__value" }
const _hoisted_17 = { class: "block__field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Логист", -1))
const _hoisted_19 = { class: "field__value" }
const _hoisted_20 = { class: "block__field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата забора", -1))
const _hoisted_22 = { class: "field__value" }
const _hoisted_23 = { class: "block__field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип FTL", -1))
const _hoisted_25 = { class: "field__value" }
const _hoisted_26 = { class: "block__field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Менеджер", -1))
const _hoisted_28 = { class: "field__value" }
const _hoisted_29 = { class: "block__field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип перевозки", -1))
const _hoisted_31 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.isNeedCar)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.companyName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.userName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.logistName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.takeDate) + ", " + _toDisplayString(_ctx.takeTime), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.ftlTypeName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.managerName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.shipmentTypeName || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}